import { render, staticRenderFns } from "./TRTAddress.vue?vue&type=template&id=40c4a254&"
import script from "./TRTAddress.vue?vue&type=script&lang=js&"
export * from "./TRTAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports